import { useState, useEffect } from 'react'
import ru from '../locales/ru.json'
import en from '../locales/en.json'
import pt from '../locales/pt.json'

type Locale = Record<string, string>
const locales: Record<string, Locale> = { ru, en, pt }

export const SUPPORTED_LANGS = Object.keys(locales)

export function translate(key: string, lang: string, vars?: Record<string, string | number>): string {
  const locale = locales[lang] ?? locales['en']!
  let str = (locale as Locale)[key] ?? (en as Locale)[key] ?? key
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replaceAll(`{${k}}`, String(v))
    }
  }
  return str
}

export function getTelegramLang(): string {
  try {
    const raw = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code
    if (!raw) return 'en'
    // Точное совпадение (ru, en, pt)
    if (locales[raw]) return raw
    // Обрезаем регион: pt-BR → pt, zh-Hans → zh
    const base = raw.split('-')[0]?.split('_')[0] ?? 'en'
    return locales[base] ? base : 'en'
  } catch {
    return 'en'
  }
}

// Dev-only override — в продакшене не используется
let _devLang: string | null = null

export function setDevLang(lang: string): void {
  _devLang = lang
  window.dispatchEvent(new Event('devlangchange'))
}

// Язык из API (приоритетнее Telegram initData)
let _apiLang: string | null = null

export function setApiLang(lang: string): void {
  if (locales[lang]) {
    _apiLang = lang
    window.dispatchEvent(new Event('apilangchange'))
  }
}

export function useTranslation() {
  const [lang, setLang] = useState(() =>
    import.meta.env.DEV && _devLang ? _devLang : (_apiLang ?? getTelegramLang())
  )

  useEffect(() => {
    const handler = () => {
      if (import.meta.env.DEV && _devLang) {
        setLang(_devLang)
      } else {
        setLang(_apiLang ?? getTelegramLang())
      }
    }
    window.addEventListener('devlangchange', handler)
    window.addEventListener('apilangchange', handler)
    return () => {
      window.removeEventListener('devlangchange', handler)
      window.removeEventListener('apilangchange', handler)
    }
  }, [])

  return {
    t: (key: string, vars?: Record<string, string | number>) => translate(key, lang, vars),
    lang,
  }
}
